import { Power } from '@material-ui/icons'
import React from 'react'
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";

import PowerAIBanner from './PowerAIBanner'
import SeoFeatures from './SeoFeatures'
import AIFeaturesBuiltforJewelryRetailer from './AIFeaturesBuiltforJewelryRetailer'
import HowItWorks from './HowItWorks'
import { Container } from 'react-bootstrap';
import PowerOfAiFaq from './PowerOfAiFaq';

const PowerOfAi = () => {
  return (
    <div className='bw_power_of_ai_sectopn'>
        <PowerAIBanner />
        <SeoFeatures/>
        <AIFeaturesBuiltforJewelryRetailer/>
        <HowItWorks/>
        <PowerOfAiFaq/>

           
    </div>
  )
}

export default PowerOfAi